import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { PartneriPopisService } from './partneri-popis.service';
import * as toastr from 'toastr';
import { PartnerPopis } from './partneri-popis';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';

import * as alertify from 'alertify.js';

@Component({
  selector: 'app-partneri-popis',
  templateUrl: './partneri-popis.component.html',
  styleUrls: ['./partneri-popis.component.css'],
  providers: [PartneriPopisService]
})
export class PartneriPopisComponent implements OnInit {

  partnerOptions: DataTables.Settings = {};
  sviPartneri: PartnerPopis[] = [];
  partnerTrigger: Subject<PartnerPopis> = new Subject();

  partnerForma: FormGroup;
  partnerEditForma: FormGroup;

  constructor(
    private _fb: FormBuilder,
    private _partneriPopisService: PartneriPopisService,
    public _router: Router
  ) { }

  ngOnInit() {
    this.dohvati();
    //Tablica početak
    this.partnerOptions = {
      pagingType: 'full_numbers',
      pageLength: 50,
      responsive: true,
      columnDefs: [{
          targets: 'no-sort',
          orderable: false
      }],
      retrieve: true
  };
  //Tablica kraj
  this.partnerForma = this._fb.group({
    oib: [''],
    nazivtvrtke: [''],
    telefon: [''],
    ulica: [''],
    grad: [''],
    email: ['']
  });
  this.partnerEditForma = this._fb.group({
    id: [''],
    oib: [''],
    nazivtvrtke: [''],
    telefon: [''],
    ulica: [''],
    grad: [''],
    email: ['']
  });
  }

  pripremiPodatke(partner){
    this.partnerEditForma = this._fb.group({
      id: partner['id'],
      nazivtvrtke: partner['nazivtvrtke'],
      oib: partner['oib'],
      telefon: partner['telefon'],
      ulica: partner['ulica'],
      grad: partner['grad'],
      email: partner['email']
    });
  }

  uredi(partner){
    let objektZaSlanje = {
      'idpartner': partner['id'],
      'nazivtvrtke': partner['nazivtvrtke'],
      'oib': partner['oib'],
      'telefon': partner['telefon'],
      'ulica': partner['ulica'],
      'grad': partner['grad'],
      'email': partner['email'],
      'access_token': localStorage.getItem('tokenSql')
    }
    this._partneriPopisService.urediPartnera(objektZaSlanje).subscribe(res => {
      if(res.success == true){
        toastr.success("Uspješno uređivanje!");
        $('#partneriTablica').DataTable().destroy();
        this.partnerEditForma = this._fb.group({
          oib: [''],
          nazivtvrtke: [''],
          telefon: [''],
          ulica: [''],
          grad: [''],
          email: ['']
        });
        this.dohvati();
      } else {
         toastr.error(res.message);
      }
    });
  }

  spremiPartnera(){
    this._partneriPopisService.dodajPartnera(this.partnerForma.value).subscribe(res => {
      if(res.success == true){
        //toastr.success("Uspješno dodan partner!");
        toastr.success(res.data[0][0].poruka);
        $('#partneriTablica').DataTable().destroy();
        this.partnerForma = this._fb.group({
          oib: [''],
          nazivtvrtke: [''],
          telefon: [''],
          ulica: [''],
          grad: [''],
          email: ['']
        });
        this.dohvati();
      } else {
        toastr.error(res.message);
      }
    });
  }

  provjeriOIB(partnerForma){
    if(partnerForma.value.oib.length == 11){
       this._partneriPopisService.sudskiRegistar(partnerForma.value.oib).subscribe(res => {
        if(res){
          if(res.sjedista[0].kucni_podbroj){
            this.partnerForma = this._fb.group({
              oib: partnerForma.value.oib,
              nazivtvrtke: res.skracene_tvrtke[0].ime,
              telefon: [''],
              ulica: res.sjedista[0].ulica + ' ' + res.sjedista[0].kucni_broj + res.sjedista[0].kucni_podbroj,
              grad: res.sjedista[0].naziv_naselja,
              email: ['']
            });
          } else {
            this.partnerForma = this._fb.group({
              oib: partnerForma.value.oib,
              nazivtvrtke: res.skracene_tvrtke[0].ime,
              telefon: [''],
              ulica: res.sjedista[0].ulica + ' ' + res.sjedista[0].kucni_broj,
              grad: res.sjedista[0].naziv_naselja,
              email: ['']
            });
          }
        } else {
          toastr.error("Neuspješno dohvaćanje podataka prema OIB-u!");
        }
       });
    } else {
      //
    }
  }

  dohvati(){
    this.sviPartneri = [];
    this._partneriPopisService.dohvatiPartnere({}).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        for(let i = 0; i < res.data.length; i++){
          this.sviPartneri.push({
            'id': res.data[i]['idpartner'],
            'nazivtvrtke': res.data[i]['pa_nazivtvrtke'],
            'oib': res.data[i]['pa_oib'],
            'email': res.data[i]['pa_email'],
            'telefon': res.data[i]['pa_telefon'],
            'ulica': res.data[i]['pa_ulica'],
            'grad': res.data[i]['pa_grad'],
            'aktivan': res.data[i]['pa_aktivan']
          });
        }
        this.partnerTrigger.next();
      } else {
        toastr.error("Neuspješno dohvaćanje!");
      }
    });
  }

  obrisiPartnera(partner){
    //console.log(partner);
    let ovo = this;
    alertify
    .okBtn("Obriši")
    .cancelBtn("Odustani")
    .confirm("Jeste li sigurni da želite obrisati partnera?", function (ev) {
      ev.preventDefault();
      if (alertify.success){
        ovo._partneriPopisService.partnerDelete({'idpartner': partner.id}).subscribe(res => {
          //console.log(res);
          if(res.success == true){
            toastr.success("Partner uspješno obrisan!");
            ovo.dohvati();
          } else {
            toastr.error(res.message);
          }
        })
      }
    }, function(ev) {
      ev.preventDefault();
      toastr.info('Odustali ste od brisanja partnera.');
    });
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.partnerTrigger.unsubscribe();
  }

}


// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/virtualna-ucionica/partneri-popis/partneri-popis.component.ts